import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const fetchViolatePolicyOrders = createAction(Constants.FETCH_VIOLATE_POLICY_ORDERS.REQUEST);

export const updateReason = createAction(Constants.UPDATE_REASON.REQUEST);
